import { h, Fragment, Component } from "preact";
import { useRef, useEffect } from "react";

export const CustomFacet = ({filter, values, facetSelected, setFacetSelected, facets, initialFilterArrayofObjects, preSelectedOptionArrayofObjects}) => {

  //Initialize empty variables we need
  let isActive = {};
  let isStillAvailable = [];
  let automaticSelect = [];

  //Grab data from latest useState Facets
  facets.map((field) => {
    if(field.field == filter.field) {
      //Loop through, check any that are active and match the current Facet Field name
      if(field.facet_active == 1) {
        field.values.map((values) => {
          if(values.active == true) {
            //If something is active, add to empty object
            isActive[values.value] = values.active;
          }
        });
      }

      //Add all available facets from our latest state to our empty array
      field.values.map((values) => {
        isStillAvailable.push(values.value);
      });
    }

    //If a field only has 1 available option left
    //Select it automatically
    if(field.values.length == 1){
      //Loop through the available value
      field.values.map((values) => {
        let findThis = "";

        //Loop through initial filter array
        initialFilterArrayofObjects.map((initialFilter) => {
          //Make sure it doesnt equal any of those, we don't want to mess with the original filters
          if(initialFilter.filterValue != values.label) {

            if(document.querySelector(`[data-ss-value-label='${values.label}']`)) {
              //Find the value in the DOM. Grab its Field via attributes
              findThis = document.querySelector(`[data-ss-value-label='${values.label}']`).dataset.ssField;
            }

            if(findThis) {
              //Add the value to automatic select array
              if(automaticSelect.filter(existingFilter => existingFilter.filterValue == values.value).length <= 0){
                //Sanitize any special characters from the label that may interfere with api URL request
                const valueLabel = encodeURIComponent(values.label);

                //This will be added to updateSelectedFacets later
                automaticSelect = [
                  ...automaticSelect,
                  {
                    filterField: findThis,
                    filterValue: valueLabel
                  }
                ]
              }
            }
          }
        });
      });
    }
  });

  //On Initial Load, automatically select any filters by themselves
  //On option select this logic is handled beloow, but this is for load only
  //Loop through any facets that should be Automatic Selected, detected from above logic
  automaticSelect.map((automaticFacet) => {
    //If the filter we want is not already selected
    //Then push it up to setFacetSelected
    if (facetSelected.filter(facet => facet.filterValue == automaticFacet.filterValue).length == 0) {
      let filteredArray = [];

      //Filter out any other fields that are selected in this same category
      //Push to new array
      filteredArray = facetSelected.filter(function(value) {
        return value.filterField != filter.field;
      });

      //Add automatic selection along with predefined filters on initial load
      const updateSelectedFacets = [
        ...filteredArray,
        ...automaticSelect
      ];
      
      // Update the state
      setFacetSelected(updateSelectedFacets);
    }
  });

  //Turn isActive object into array of objects. Easier to .map()
  let isActiveArray = Object.entries(isActive);

  //On initial load ONLY - see if there are any filters to Preselect
  useEffect(() => {
    let preSelectFinalArray = [];

    if(preSelectedOptionArrayofObjects) {
      preSelectedOptionArrayofObjects.map((key) => {
        let findValuesFieldName = "";

        initialFilterArrayofObjects.map((initialFilter) => {

          //Make sure a preselected filter listed isnt an Initial filter
          //Those are different and should not be touched
          if(initialFilter.filterValue != key) {
            const valueLabel = encodeURIComponent(key);

            //Find a preselected value's field name
            if(document.querySelector(`[data-ss-value-label='${key}']`)) {
    
              //Find the value in the DOM. Grab its Field via attributes
              findValuesFieldName = document.querySelector(`[data-ss-value-label='${key}']`).dataset.ssField;
    
              if(findValuesFieldName) {
                //Add the value to preselected array if not already present
                if(preSelectFinalArray.filter(preSelect => preSelect.filterValue == valueLabel).length <= 0){
  
                  preSelectFinalArray = [
                    ...preSelectFinalArray,
                    {
                      filterField: findValuesFieldName,
                      filterValue: valueLabel
                    }
                  ]
                }
              }
            }
          }
        });
      });
    }

    preSelectFinalArray.map((preSelectFinalArrayItem) => {
      //If the filter we want is not already selected
      //Then push it up to setFacetSelected
      if (facetSelected.filter(facet => facet.filterValue == preSelectFinalArrayItem.filterValue).length == 0) {
        let filteredArray = [];

        //Filter out any other fields that are selected in this same category
        //Push to new array
        filteredArray = facetSelected.filter(function(value) {
          return value.filterField != filter.field;
        });

        //Add preselected filters, along with initial filters
        const updateSelectedFacets = [
          ...filteredArray,
          ...preSelectFinalArray
        ];

        // Update the state
        setFacetSelected(updateSelectedFacets);
      }
    });
  }, []);


  const onClickFacet = function(event){

    //Only populate this function if the current value is available to click
    //Otherwise, will cause Searchspring API errors, and will allow customer to filter to zero products
    if(isStillAvailable.includes(values.label)) {
      let thisElement = event.target;
      let thisParentField = thisElement.dataset.ssField;

      //OnClick, see if this filter is already selected or not
      if (facetSelected.filter(facet => facet.filterValue == encodeURIComponent(values.label)).length > 0) {
        //Remove filter from array if already selected
        facetSelected.map((value) => {
          if(value.filterValue == encodeURIComponent(values.label)) {
            setFacetSelected(facetSelected.filter(value => value.filterValue != encodeURIComponent(values.label)));
          }
        });
      }
      else {
        //Create an empty array to push filter to
        let filteredArray = [];

        //Filter out any other fields that are selected in this same category
        //Push to new array
        filteredArray = facetSelected.filter(function(value) {
          return value.filterField != filter.field;
        });

        //Sanitize any special characters from the label that may interfere with api URL request
        const valueLabel = encodeURIComponent(values.label);

        //Add new selection to search query API params, w/ any filtered out selections in same category
        const updateSelectedFacets = [
          ...filteredArray,
          ...automaticSelect,
          {
            filterField: thisParentField,
            filterValue: valueLabel
          }
        ];
        
        // Update the state to the updatedUsers
        setFacetSelected(updateSelectedFacets);
      }

      //Just a test, please leave here for now
      refTest();
    }
  }

  const facetRef = useRef(null);
  const refTest = function() {
    //Just a test, please leave here for now
    // console.log(facetRef.current);
  }

  return (
    <>
      <p 
        className={`facet-state__facets__value text-body 
          ${isActiveArray.filter(filter => filter[0] == values.label).length > 0 ? "active--true" : ""}
          ${!isStillAvailable.includes(values.label) ? "facet--is-turned-off" : "facet--is-not-turned-off"}
          ${automaticSelect.filter(filter => filter.filterValue == values.label).length > 0 ? "only-one-left" : ""}
        `}
        ref={facetRef}
        data-ss-field={filter.field}
        data-ss-value-label={values.label}
        onClick={(event) => {
          onClickFacet(event);
        }}
      >
        {values.label}
      </p>
    </>
  )
}